export const productSimpleOptions = {
  readOnly: [
    {
      resource: '/products',
      actions: ['GET']
    },
    {
      resource: '/products/{productId}',
      actions: ['GET']
    },
    {
      resource: '/products/{productId}/variations/{sku}',
      actions: ['GET']
    }
  ],
  readAndWriting: [
    {
      resource: '/products',
      actions: ['GET', 'POST']
    },
    {
      resource: '/products/{productId}',
      actions: ['GET', 'PATCH']
    },
    {
      resource: '/products/{productId}/variations',
      actions: ['POST']
    },
    {
      resource: '/products/{productId}/variations/{sku}',
      actions: ['GET', 'PATCH']
    },
    {
      resource: '/modules/{identifier}/products/{sku}/price',
      actions: ['PUT']
    }
  ]
}

export const orderSimpleOptions = {
  readOnly: [
    {
      resource: '/orders',
      actions: ['GET']
    },
    {
      resource: '/orders/{code}',
      actions: ['GET']
    },
    {
      resource: '/modified/orders',
      actions: ['GET', 'DELETE']
    }
  ],
  readAndWriting: [
    {
      resource: '/orders',
      actions: ['GET']
    },
    {
      resource: '/orders/{code}',
      actions: ['GET']
    },
    {
      resource: '/orders/{code}/invoice',
      actions: ['POST']
    },
    {
      resource: '/orders/{code}/shipping',
      actions: ['POST']
    },
    {
      resource: '/orders/{code}/delivered',
      actions: ['POST']
    },
    {
      resource: '/modified/orders',
      actions: ['GET', 'DELETE']
    }
  ]
}

export const productAdvancedOptions = [
  {
    resource: '/products',
    actions: {
      GET: false,
      POST: false
    }
  },
  {
    resource: '/products/{productId}',
    actions: {
      GET: false,
      PATCH: false
    }
  },
  {
    resource: '/products/{productId}/variations',
    actions: {
      POST: false
    }
  },
  {
    resource: '/products/{productId}/variations/{sku}',
    actions: {
      GET: false,
      PATCH: false
    }
  },
  {
    resource: '/modules/{identifier}/products/{sku}/price',
    actions: {
      PUT: false
    }
  }
]

export const orderAdvancedOptions = [
  {
    resource: '/orders',
    actions: {
      GET: false
    }
  },
  {
    resource: '/orders/{code}',
    actions: {
      GET: false
    }
  },
  {
    resource: '/orders/{code}/invoice',
    actions: {
      POST: false
    }
  },
  {
    resource: '/orders/{code}/shipping',
    actions: {
      POST: false
    }
  },
  {
    resource: '/orders/{code}/delivered',
    actions: {
      POST: false
    }
  },
  {
    resource: '/modified/orders',
    actions: {
      GET: false,
      DELETE: false
    }
  }
]



// WEBPACK FOOTER //
// ./src/storage/tokenPermissions.js